//LINK SHARING MUST BE SET TO "ANYONE" FOR GOOGLE SHEET
const sheetKey = "12FUe5Y7Il-uGp95hsdvofMGF73M5UmVluKcCPm_M1Kk";
export default sheetKey;
